import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { Container, Button, Paper, Dialog, Box, Typography, Snackbar, FormControlLabel, Checkbox } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
import UploadImage from "./uploadImage";
import { useGetListProductsMutation } from '../../services/product';
const API_URI = process.env.REACT_APP_API_URI;

export default function Products() {
	ModuleRegistry.registerModules([ AllCommunityModule ]);
	const [getListProducts, listListProductsResult] = useGetListProductsMutation();
	const [selectedRecord, setSelectedRecord] = useState({});
	const [dataLoaded, setDataLoaded] = useState([]);
	const [columns, setCoumns] = useState([]);
	const [gridHeight, setGridHeight] = useState(300);
	const [openUpload, setOpenUpload] = useState(false);
	const [alert, setAlert] = useState(false);
	const [noImage, setNoImage] = useState(false);
	const [noImageEcom, setNoImageEcom] = useState(false);

	useEffect(() => {
		loadData();

		const divHeader = document.getElementById('divHeader');
    setGridHeight(window.innerHeight - (divHeader?divHeader.clientHeight:0) - 72);
	}, []);

	useEffect(() => {
		if(listListProductsResult && listListProductsResult.data){
			let dt = listListProductsResult.data;
			if(typeof listListProductsResult.data === "string")
				dt = JSON.parse(listListProductsResult.data);
			setDataLoaded(dt);
			getCoumns(dt[0]);
		}
	}, [listListProductsResult]);

	const loadData=()=>{
		const formData = new FormData();
    formData.append("data", JSON.stringify({noImage: noImage?1:0, noImageEcom: noImageEcom?1:0}));
		getListProducts(formData);
	}

	const uploadResult=(value)=>{
		setOpenUpload(false);
		let data = [...dataLoaded];
		const index = data.findIndex(f=>f == selectedRecord);
		let item = {...data[index]};
		item.IMAGE = value;
		data[index] = item;
		setDataLoaded(data);
	}

	const getCoumns=(item)=>{
		const cols = Object.keys(item).map((key) => {
			return {
				field: key,
				filter: ((key=="IMAGE" || key=="ImageEcom") ? false : true),
				resizable: true,
				hide: (key == 'CODE' ? true : false),
				cellStyle: () => ((key=="IMAGE" || key=="ImageEcom")
				?{
					display: "flex",
					alignItems: "center",
					justifyContent: "center"
				}:null),
				width: (key == "DESC" ? 300 : 200),
				cellRenderer: (props) => ((key == "IMAGE" || key == "ImageEcom") ? CustomCell(props, key) : props.value)
			}
		});
		setCoumns(cols);
	}

	const CustomCell = (props, key) => {
		const handleClick = () => {
			setSelectedRecord(props.data);
			setOpenUpload(true);
		};
		return key=='IMAGE'?<Button onClick={handleClick}>
			{props.data.IMAGE ?
			<Box
				component="img"
				src={`${API_URI}/uploads/products/${props.data.IMAGE}`}
				sx={{ width: 30, height: 30, objectFit: "cover", borderRadius: 2, }}
			/>
			:"No Image"}
			</Button>:props.data.ImageEcom ?<Box
				component="img"
				src={`${props.data.ImageEcom}`}
				sx={{ width: 40, height: 40, objectFit: "cover", borderRadius: 2,
					// border: "1px solid #eee",
					// textAlign: "center", lineHeight: '18px', color: 'silver'
				}}
			/>:"No Image";
	};

	const getRowClass = useCallback(params => {
		if (params.node.rowIndex % 2 === 1) {
				return "grid-odd-rows";
		}
		if (params.node.rowPinned === 'bottom') {
			return "text-bold";
		}
	}, []);

	const myTheme = themeQuartz.withParams({
		// borderColor: "#9696C8",
		wrapperBorder: false,
		headerRowBorder: false,
		// rowBorder: { style: "dotted", width: 1 },
		columnBorder: { style: "dashed", color: '#9696C8' },
		headerColumnBorder: { style: 'solid', width: 1, color: '#ccc' },
	});

	const theme = useMemo(() => {
		return myTheme;
	}, []);
	return (
		<Container maxWidth="xl" sx={{ p: 2 }}>
			<div id='divHeader'>
				<FormControlLabel sx={{ ml: 0.65 }} control={<Checkbox onChange={(e)=>setNoImage(e.target.checked)} />} label="Không có hình" />
				<FormControlLabel control={<Checkbox onChange={(e)=>setNoImageEcom(e.target.checked)} />} label="Không có hình Ecom" />
				<Button variant="contained" onClick={loadData}
					sx={{ margin: '0 0 10px 0' }}>View</Button>
			</div>
			<Paper sx={{ height: gridHeight, width: '100%', float: 'left' }}>
				<AgGridReact
					rowData={dataLoaded}
					columnDefs={columns}
					pagination={true}
					paginationPageSize={30}
					paginationPageSizeSelector={[30, 100, 200]}
					getRowClass={getRowClass}
					theme={theme}
				/>
			</Paper>
			<Dialog onClose={()=>setOpenUpload(false)} open={openUpload} maxWidth="xs"
				sx={{
					"& .MuiPaper-root": { margin: 0 }, // Chrome/Safari
				}} >
				<UploadImage record={selectedRecord} setAlert={setAlert} uploadResult={uploadResult}/>
			</Dialog>
			<Snackbar
				open={alert}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
				autoHideDuration={6000}
				onClose={()=>setAlert(false)}
				message={alert}
			/>
		</Container>
	)
}